module.exports = __webpack_public_path__ + "img/ch35.667d8028.png";